export type Balance = {
  boosts: number;
  free_reveal_bonus_next_at?: number;
  free_smashes_bonus_next_at?: number;
  free_super_smashes_bonus_next_at?: number;
  has_free_reveal: boolean;
  smashes: number;
  super_smashes: number;
};

export const defaultBalance: Balance = {
  boosts: 0,
  has_free_reveal: true,
  smashes: 0,
  super_smashes: 0,
};
